import { Headers } from '@egw/components'
import { CompanionAccountHoldings } from '@egw/features-holdings'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentsCompanionAccountHoldingsPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.investment.title')} />
      <CompanionAccountHoldings />
    </Layout>
  )
}
